import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", { class: "top-part" }, null, -1)
const _hoisted_2 = { class: "content" }
const _hoisted_3 = {
  key: 0,
  class: "social-cards cards"
}
const _hoisted_4 = { key: 1 }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("h2", null, "Overview - Today", -1)
const _hoisted_6 = { class: "social-overview-cards cards" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_app_header = _resolveComponent("app-header")!
  const _component_social_card = _resolveComponent("social-card")!
  const _component_social_overview_card = _resolveComponent("social-overview-card")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["dashboard theme", _ctx.appTheme])
  }, [
    _hoisted_1,
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_app_header, {
        theme: _ctx.theme,
        followers: _ctx.followers,
        onThemeChanged: _ctx.setTheme
      }, null, 8, ["theme", "followers", "onThemeChanged"]),
      (_ctx.socialNetworkProfiles)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.socialNetworkProfiles.sort((a,b) => _ctx.socialCardsSortOrder[a.SocialNetworkName] - _ctx.socialCardsSortOrder[b.SocialNetworkName]), (social) => {
              return (_openBlock(), _createBlock(_component_social_card, {
                key: social,
                social: social
              }, null, 8, ["social"]))
            }), 128))
          ]))
        : _createCommentVNode("", true),
      (_ctx.socialNetworkProfiles)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
            _hoisted_5,
            _createElementVNode("div", _hoisted_6, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.socialOverview, (overview) => {
                return (_openBlock(), _createBlock(_component_social_overview_card, {
                  key: overview,
                  overview: overview
                }, null, 8, ["overview"]))
              }), 128))
            ])
          ]))
        : _createCommentVNode("", true)
    ])
  ], 2))
}